import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpcionRecomendador } from '../../model/opcion-recomendador.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-opcion-recomendador',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule
	],
	templateUrl: './opcion-recomendador.component.html',
	styleUrls: ['./opcion-recomendador.component.scss']
})
export class OpcionRecomendadorComponent {
	@Input() opcion!: OpcionRecomendador;
  	@Input() seleccionada: boolean = false;
	@Input() deshabilitada: boolean = false;

  	@Output() seleccionarOpcion = new EventEmitter<OpcionRecomendador>();

	seleccionar() {
		this.seleccionarOpcion.emit(this.opcion);
	}
}
